import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { FDBox, FDStack } from '@facet-wealth/design';
import {
  ThreadParticipant,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MessagesPanelContent/components/ThreadHeader/components/ThreadParticipant/ThreadParticipant';


const ThreadParticipants = ({
  threadParticipants,
  direction,
}) => {
  const isColumn = direction === 'column';

  return (
    <FDBox flexGrow={1}>
      <FDStack
        direction={direction}
        justifyContent={isColumn ? 'flex-start' : 'flex-end'}
        alignItems={isColumn ? 'flex-start' : 'center'}
      >
        {threadParticipants.map(threadParticipant => (
          <ThreadParticipant
            key={threadParticipant.id()}
            avatarSrc={threadParticipant.relationship(fr.relationships.profileImage.name)?.link('related').url()}
            name={threadParticipant.attr('name')}
            role={threadParticipant.attr('role')}
          />
        ))}
      </FDStack>
    </FDBox>
  );
};

ThreadParticipants.defaultProps = {
  direction: 'row',
};

ThreadParticipants.propTypes = {
  threadParticipants: PropTypes.arrayOf(fr.Resource).isRequired,
  direction: PropTypes.string,
};

export { ThreadParticipants };
